<template>
  <div></div>
</template>

<script>
import userManager from "@/modules/auth/user-manager";

export default {
  name: "Callback",
  created() {
    const vm = this;
    userManager
      .signinRedirectCallback()
      .then(async function () {
        await vm.$store.dispatch("auth/oidc/loadUser");
        const returnUrl = sessionStorage.getItem("login_return_url") || "/";
        vm.$router.push(returnUrl);
      })
      .catch(function (e) {
        window.console.error(e, 'errooooooooooooooooor');
      });
  },
};
</script>